/**
 * @ngdoc directive
 * @name payments.directive:contact
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example <payments contact=''></payments>
 *
 */
import FestzeltOSSeatPlanDrawing from '../scripts/drawing.seatplans.festzelt-os';

angular
    .module('festzelt-os.seatplans')
    .controller('SeatplanGroupCtrl', [
        '$attrs',
        '$element',
        '$http',
        'Env',
        '$scope',
        '$filter',
        'Deposit',
        '$injector',
        SeatplanGroupCtrl
    ]);

function SeatplanGroupCtrl($attrs, $element, $http, Env, $scope, $filter, Deposit, $injector) {
    const vm = this;

    vm.availableStates = {};
    vm.error = '';
    vm.showError = false;
    vm.loading = false;
    vm.showCanvas = false;
    vm.blockMultipleSelectionOfOneElement = false;
    vm.lastBuilderInformation = null;
    vm.bookingInformation = vm.bookingInformation || [];
    vm.bookingInformationArray = [];
    vm.canvasElement = angular.element($element[0].querySelector('canvas'));
    vm.tooltipElement = angular.element($element[0].querySelector('.seatplan-info'));
    vm.drawing = null;
    vm.drawInfo = null;
    vm.resetSelected = 0;
    vm.showLegend = false;
    vm.infoWindowData = false;
    vm.showInfo = false;
    vm.mouse = {
        x: 0,
        y: 0
    };
    vm.tooltipPos = {
        x: 0,
        y: 0
    };
    vm.$timeout = $injector.get('$timeout');

    vm.allowElementMultiSelection = _.get($injector.get('Users'), 'state.company.settings.seatplans.enable_multiple_bookings_per_element')

    $attrs.$observe('groupId', function (val) {
        if (!vm.loading) {
            vm.groupId = val;
            init();
        }
    });

    $scope.$watch('vm.bookingInformation', function (val) {
        vm.bookingInformationArray = [];
        _.each(vm.bookingInformation, (v) => {
            vm.bookingInformationArray.push(v);
        });
        if (!vm.loading) {
            if (!vm.drawing) {
                initDrawing();
            } else {
                vm.drawInfo = prepareDrawInfoFromResponse(angular.copy(vm.lastBuilderInformation));
                vm.drawing.updateDrawInfo(vm.drawInfo);
            }
        }
    });

    $scope.$watch('vm.blockMultipleSelectionOfOneElement', function (val) {
        if (!vm.loading) {
            if (!vm.drawing) {
                initDrawing();
            } else {
                vm.drawInfo = prepareDrawInfoFromResponse(angular.copy(vm.lastBuilderInformation));
                vm.drawing.updateDrawInfo(vm.drawInfo);
            }
        }
    });

    $scope.$watch('vm.currentSelected', function (val) {
        if (vm.drawing && vm.currentSelected && vm.currentSelected.length > 0) {
            vm.drawing.setSelected(val, 'unbooked');
            _fireFullSelectionChangeEvent(vm.drawing.getSelected());
        }
    }, true);

    $scope.$watch('vm.resetSelected', function (val) {
        if (!vm.loading) {
            vm.drawing.resetSelected();
        }
    });

    $attrs.$observe('clickable', function (val) {
        if (!vm.loading) {
            vm.clickable = !(val === 'false');
            init();
        }
    });

    Deposit.getRemoteDeposit('rsvps', 'states', []).then((value) => {
        vm.availableStates = value;
    });

    init();

    function init() {
        hideError();
        if (!vm.groupId) {
            showError('Invalid Group ID given');
            return;
        }
        startLoading();

        $http.get(Env.apiUrl + '/seatplans/groups/' + vm.groupId + '/builder').then(function (response) {
            vm.lastBuilderInformation = angular.copy(response.data);
            initDrawing();
        }, function (response) {
            showError('Error while Loading canvas data');
        });
    }

    function initDrawing() {
        if (vm.lastBuilderInformation !== null) {
            vm.drawInfo = prepareDrawInfoFromResponse(angular.copy(vm.lastBuilderInformation));
            createDrawing();
        }
    }

    function createDrawing() {
        resizeCanvas();
        if (vm.drawing) {
            vm.drawing.destruct();
        }
        vm.drawing = new FestzeltOSSeatPlanDrawing(vm.canvasElement[0],
            vm.drawInfo, {
                click: function (e, clickedElement) {
                    if (vm.onClick) {
                        vm.onClick({e: e, clickedElement: clickedElement});
                    }
                },
                dblClick: function (e, clickedElement) {
                    if (vm.onDblClick) {
                        vm.onDblClick({e: e, clickedElement: clickedElement});
                    }
                },
                selectionChange: function (triggeredElement, selectionState, allSelectedElements) {
                    if (vm.onSelectionChange) {
                        vm.onSelectionChange({
                            triggeredElement: triggeredElement,
                            selectionState: selectionState,
                            allSelectedElements: allSelectedElements
                        });
                    }

                    _fireFullSelectionChangeEvent(allSelectedElements);
                },
                unSelectable: function (clickedElement) {
                    if (vm.onUnSelectable) {
                        vm.onUnSelectable({clickedElement: clickedElement});
                    }
                },
                hoverChange(hoverElem) {
                    vm._updateInfoWindow(hoverElem);
                    // console.log('hoverchange', hoverElem);
                }
            }, false, vm.allowElementMultiSelection);
        vm.showCanvas = true;
        if (vm.currentSelected && _.isArray(vm.currentSelected) && vm.currentSelected.length > 0) {
            vm.drawing.setSelected(vm.currentSelected, 'unbooked');
            _fireFullSelectionChangeEvent(vm.drawing.getSelected());
        }
        stopLoading();
    }

    function _fireFullSelectionChangeEvent(allSelectedElements) {
        if (vm.onFullSelectionUpdate) {
            vm.onFullSelectionUpdate({
                allSelectedElements: allSelectedElements
            });
        }
    }

    function prepareDrawInfoFromResponse(dataFromApi) {
        dataFromApi.objects = prepareDrawObjectsList(dataFromApi.objects);
        return dataFromApi;
    }

    function getHoverWithIds(drawObject) {
        const out = [];

        _.each(getAllObjectsForDrawObjectsBooking(drawObject), (curObj) => {
            if (curObj[0].id !== drawObject.id) {
                out.push(curObj[0].element.id);
            }
        });

        return out;
    }

    function getAllObjectsForDrawObjectsBooking(drawObject) {
        let out = [];

        if (vm.bookingInformation[drawObject.id]) {
            const ownBookingInformation = vm.bookingInformation[drawObject.id];
            const ownRsvpIds = ownBookingInformation.map((bookingInfo) => bookingInfo.rsvp.id);

            _.each(vm.bookingInformation, function (v, k) {
                if (
                    v
                        .filter((bookingInfo) => ownRsvpIds.includes(bookingInfo.rsvp.id))
                        .length > 0
                ) {
                    out.push(v);
                }
            });
        }

        return out;
    }

    function prepareDrawObjectsList(drawObjectList) {
        for (let i = 0; i < drawObjectList.length; i++) {
            const currentDrawObject = drawObjectList[i];
            if (currentDrawObject.objects && currentDrawObject.objects.length) {
                currentDrawObject.objects = prepareDrawObjectsList(currentDrawObject.objects);
            }

            if (currentDrawObject.bookable) {
                if (vm.blockedElements && vm.blockedElements.indexOf(currentDrawObject.id) > -1) {
                    currentDrawObject.blocked = true;
                    currentDrawObject.clickable = false;
                    currentDrawObject.selectable = false;
                } else if (vm.bookingInformation && vm.bookingInformation[currentDrawObject.id] && vm.bookingInformation[currentDrawObject.id].length > 0) {
                    currentDrawObject.status = vm.bookingInformation[currentDrawObject.id][0].rsvp.status;
                    currentDrawObject.clickable = vm.clickable;

                    currentDrawObject.selectable = vm.allowElementMultiSelection && !vm.blockMultipleSelectionOfOneElement;

                    currentDrawObject.subs = []

                    let fullElementPax = currentDrawObject.pax;
                    const allSubsPax = vm.bookingInformation[currentDrawObject.id].reduce((out, subElem) => out+subElem.pax, 0)
                    if(allSubsPax > fullElementPax) {
                        fullElementPax = allSubsPax;
                    }

                    for(let j = 0; j<vm.bookingInformation[currentDrawObject.id].length; j++) {
                        const curSub = vm.bookingInformation[currentDrawObject.id][j];
                        const curSubPercentage = (curSub.pax / fullElementPax) * 100

                        currentDrawObject.subs.push({
                            status: curSub.rsvp.status,
                            fillPercentage: curSubPercentage,
                            realFillPercentage: (curSub.pax / currentDrawObject.pax) * 100,
                            customTime: curSub.rsvp.custom_start_time || curSub.rsvp.custom_end_time,
                            alreadyPaid: ['invoice', 'bid'].includes(curSub.rsvp.last_invoice_type) && curSub.rsvp.last_invoice_status === 'paid'
                        })
                    }

                    if (vm.bookingInformation[currentDrawObject.id][0].rsvp.blocked) {
                        currentDrawObject.border = {
                            width: 0.4,
                            color: '#40c4f1'
                        };
                    } else if (typeof currentDrawObject.border !== 'undefined') {
                        delete currentDrawObject.border;
                    }
                } else {
                    currentDrawObject.status = 'unbooked';
                    currentDrawObject.clickable = vm.clickable;
                    currentDrawObject.selectable = vm.clickable;
                }
            } else {
                currentDrawObject.clickable = false;
                currentDrawObject.selectable = false;
            }

            currentDrawObject.hoverWithIds = getHoverWithIds(currentDrawObject);

            if (vm.bookingInformation && currentDrawObject.labels) {
                const regexOnVars = /{(contact|rsvp|element|rsvp_element|rsvp_elements|general)\.([A-Za-z0-9-_]*)}/g;

                var generalBookingElementReplaceInformation = {
                    pax_sum: 0,
                    bookings_count: 0
                }

                if (vm.bookingInformation[currentDrawObject.id]) {
                    _.forEach(vm.bookingInformation[currentDrawObject.id], (curElementInformation) => {
                        generalBookingElementReplaceInformation.bookings_count += 1;
                        generalBookingElementReplaceInformation.pax_sum += curElementInformation.pax;
                    })
                }

                angular.forEach(currentDrawObject.labels, function (labels, masterKey) {
                    angular.forEach(labels, function (label) {
                        let resultToReplace,
                            strForReplace = label.text;

                        regexOnVars.lastIndex = 0;

                        while ((resultToReplace = regexOnVars.exec(label.text)) !== null) {
                            if (resultToReplace.index === regexOnVars.lastIndex) {
                                regexOnVars.lastIndex++;
                            }

                            var objectToReplaceFrom = {};

                            switch (resultToReplace[1]) {
                                case 'general':
                                    objectToReplaceFrom = generalBookingElementReplaceInformation;
                                    break;
                                case 'contact':
                                    objectToReplaceFrom = (vm.bookingInformation[currentDrawObject.id]) ? vm.bookingInformation[currentDrawObject.id][0].contact : {};
                                    break;
                                case 'rsvp':
                                    objectToReplaceFrom = (vm.bookingInformation[currentDrawObject.id]) ? vm.bookingInformation[currentDrawObject.id][0].rsvp : {};
                                    break;
                                case 'rsvp_element':
                                    objectToReplaceFrom = (vm.bookingInformation[currentDrawObject.id]) ? vm.bookingInformation[currentDrawObject.id] : {};
                                    break;
                                case 'rsvp_elements':
                                    objectToReplaceFrom = (vm.bookingInformation[currentDrawObject.id]) ? vm.bookingInformation[currentDrawObject.id] : {};
                                    break;
                                case 'element':
                                    objectToReplaceFrom = currentDrawObject;
                                    break;
                            }

                            var replaceString = '';

                            if (objectToReplaceFrom && !_.isUndefined(objectToReplaceFrom[resultToReplace[2]])) {
                                replaceString = objectToReplaceFrom[resultToReplace[2]];
                            }

                            strForReplace = strForReplace.replace(resultToReplace[0], replaceString);
                        }

                        label.text = strForReplace;
                    });
                });
            }
        }
        return drawObjectList;
    }

    function startLoading() {
        vm.showCanvas = false;
        vm.showError = false;
        vm.loading = true;
    }

    function stopLoading() {
        resizeCanvas();
        vm.showCanvas = true;
        vm.loading = false;
    }

    function showError(message) {
        vm.showCanvas = false;
        stopLoading();
        vm.error = message;
        vm.showError = true;
    }

    function hideError() {
        vm.showCanvas = true;
        vm.error = '';
        vm.showError = false;
    }

    function resizeCanvas() {
        if (!vm.drawInfo) {
            return;
        }
        let format = (vm.drawInfo.grid_height / vm.drawInfo.grid_width),
            newWidth = vm.canvasElement.parent().width(),
            newHeight = newWidth * format;

        if (newHeight + vm.canvasElement.parent().offset().top + 30 > window.innerHeight) {
            newHeight = window.innerHeight - (vm.canvasElement.parent().offset().top + 30);
            newWidth = newHeight / format;
        }

        vm.canvasElement.attr('width', newWidth);
        vm.canvasElement.attr('height', newHeight);

        if (vm.drawing) {
            vm.drawing.redraw();
        }
    }

    angular.element(window).bind('resize', function () {
        resizeCanvas();
        if (vm.drawing) {
            vm.drawing.redraw();
        }
    });

    angular.element(vm.canvasElement.parent()).bind('resize', function () {
        resizeCanvas();
        if (vm.drawing) {
            vm.drawing.redraw();
        }
    });

    vm.triggerLegend = function () {
        vm.showLegend = !vm.showLegend;
    }

    vm._updateInfoWindow = function (elementToDisplayInfoFor) {
        if (!elementToDisplayInfoFor || !elementToDisplayInfoFor.bookable) {
            vm.infoWindowData = {};
            vm.showInfo = false;
            $scope.$applyAsync();
            return;
        }

        vm.infoWindowData = {
            element: elementToDisplayInfoFor,
            booking: (vm.bookingInformation[elementToDisplayInfoFor.id]) ? vm.bookingInformation[elementToDisplayInfoFor.id][0] : null,
            bookings: vm.bookingInformation[elementToDisplayInfoFor.id] ? vm.bookingInformation[elementToDisplayInfoFor.id] : [],
            bookingElements: getAllObjectsForDrawObjectsBooking(elementToDisplayInfoFor)
        };

        vm.showInfo = true;

        vm.$timeout(() => {
            vm.recalculateTooltipPos();
        })
    }

    vm.saveMouseCoordinates = function (event) {
        vm.mouse.x = event.clientX;
        vm.mouse.y = event.clientY;

        vm.recalculateTooltipPos();
    }

    vm.recalculateTooltipPos = function () {
        if(!vm.showInfo) return;

        const tooltipPos = vm.mouse;
        while(tooltipPos.x + vm.tooltipElement.width() > window.innerWidth) {
            tooltipPos.x -= 10;
        }

        while(tooltipPos.y + vm.tooltipElement.height() > window.innerHeight-50) {
            tooltipPos.y -= 10;
        }

        vm.tooltipPos = tooltipPos;

        $scope.$applyAsync();
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/seatplans/directives/seatplan-group-directive-controller.js